<template>
  <div>
  <el-table
    border
    :data="tableData"
    :header-cell-style="{'text-align':'center'}"
    :cell-style="{'text-align':'center'}"
    style="width: 100% ;margin-top: 20px;margin-bottom: 20px">
    <el-table-column
      prop="id"
      label="编号"
      width="60">
    </el-table-column>

    <el-table-column
      prop="adminName"
      label="姓名"
      width="90">
    </el-table-column>

    <el-table-column
      label="头像"
      width="85">
      <template slot-scope="scope">
        <div slot="reference" class="name-wrapper">
          <img :src="scope.row.headPortraitUrl"  height="60px" width="60px"
               style="border-radius: 50%">
        </div>
      </template>
    </el-table-column>

    <el-table-column
      label="性别"
      width="60">
      <template slot-scope="scope">
        <div slot="reference" class="name-wrapper">
          <span>{{ scope.row.sex===undefined?"":scope.row.sex===1?"男":"女" }}</span>
        </div>
      </template>
    </el-table-column>

    <el-table-column
      label="年龄"
      width="60">
      <template slot-scope="scope">
        <div slot="reference" class="name-wrapper">
          <span >{{ scope.row.age }}</span>
        </div>
      </template>
    </el-table-column>

    <el-table-column
      label="学历"
      width="60">
      <template slot-scope="scope">
        <div slot="reference" class="name-wrapper">
          <span >{{ scope.row.education }}</span>
        </div>
      </template>
    </el-table-column>

    <el-table-column
      label="qq"
      width="120">
      <template slot-scope="scope">
        <div slot="reference" class="name-wrapper">
          <span >{{ scope.row.qq }}</span>
        </div>
      </template>
    </el-table-column>

    <el-table-column
      label="身高"
      width="70">
      <template slot-scope="scope">
        <div slot="reference" class="name-wrapper">
          <span >{{ scope.row.height }}cm</span>
        </div>
      </template>
    </el-table-column>

    <el-table-column
      label="体重"
      width="60">
      <template slot-scope="scope">
        <div slot="reference" class="name-wrapper">
          <span >{{ scope.row.weight}}kg</span>
        </div>
      </template>
    </el-table-column>

    <el-table-column
      label="血型"
      width="60">
      <template slot-scope="scope">
        <div slot="reference" class="name-wrapper">
          <span >{{ scope.row.blood}}</span>
        </div>
      </template>
    </el-table-column>

    <el-table-column
      label="生日"
      width="100">
      <template slot-scope="scope">
        <div slot="reference" class="name-wrapper">
          <span >{{ scope.row.birthday}}</span>
        </div>
      </template>
    </el-table-column>

    <el-table-column
      label="学校"
      width="100">
      <template slot-scope="scope">
        <div slot="reference" class="name-wrapper">
          <span >{{ scope.row.school}}</span>
        </div>
      </template>
    </el-table-column>

    <el-table-column
      label="专业"
      width="60">
      <template slot-scope="scope">
        <div slot="reference" class="name-wrapper">
          <span >{{ scope.row.vocational}}</span>
        </div>
      </template>
    </el-table-column>

    <el-table-column
      label="英语水平"
      width="120">
      <template slot-scope="scope">
        <div slot="reference" class="name-wrapper">
          <span >{{ scope.row.englishLevel}}</span>
        </div>
      </template>
    </el-table-column>

    <el-table-column
      label="gitte地址"
      width="180">
      <template slot-scope="scope">
        <div slot="reference" class="name-wrapper">
          <span >{{ scope.row.giteeFactoryUrl}}</span>
        </div>
      </template>
    </el-table-column>

    <el-table-column
      label="CSDN地址"
      width="180">
      <template slot-scope="scope">
        <div slot="reference" class="name-wrapper">
          <span >{{ scope.row.csdnUrl}}</span>
        </div>
      </template>
    </el-table-column>

    <el-table-column
      label="GitHub地址"
      width="180">
      <template slot-scope="scope">
        <div slot="reference" class="name-wrapper">
          <span >{{ scope.row.githubUrl}}</span>
        </div>
      </template>
    </el-table-column>

    <el-table-column
      label="邮件"
      width="180">
      <template slot-scope="scope">
        <div slot="reference" class="name-wrapper">
          <span >{{ scope.row.email}}</span>
        </div>
      </template>
    </el-table-column>

    <el-table-column
      label="最近登录"
      width="85">
      <template slot-scope="scope">
        <div slot="reference" class="name-wrapper">
          <span >{{ scope.row.recentLogin}}</span>
        </div>
      </template>
    </el-table-column>

    <el-table-column
      label="注册时间"
      width="170">
      <template slot-scope="scope">
        <div slot="reference" class="name-wrapper">
          <span >{{ scope.row.createTime}}</span>
        </div>
      </template>
    </el-table-column>

    <el-table-column
      label="上次更新时间"
      width="170">
      <template slot-scope="scope">
        <div slot="reference" class="name-wrapper">
          <span >{{ scope.row.updateTime}}</span>
        </div>
      </template>
<!--      :disabled="this.tableData.id===this.id"-->
<!--      console.log(this.tableData[0].id===this.id)-->
    </el-table-column>
    <el-table-column label="操作">
      <template slot-scope="scope">
        <el-button
          :disabled="!(parseInt(scope.row.id)===parseInt(id)) "

          size="mini"
          @click="handleEdit(scope.$index, scope.row)">编辑</el-button>
      </template>
    </el-table-column>
  </el-table>


    <!--对话框-->
  <el-dialog title="管理员用户" :visible.sync="dialogFormVisible" width="600px" top="10px"
             :lock-scroll="false" :close-on-click-modal="false" :close-on-press-escape="false"
             @close="cancel('formData')"
  >
    <el-form :model="formData" status-icon ref="formData" :rules="rules"
             :inline="true"
             label-width="100px" >
<!--      div里的内容-->
      <div class="leftDialog">

        <el-form-item label="头像：" prop="headPortraitUrl" style="width: 350px;margin-left: 100px">
          <el-upload
            v-model="formData.headPortraitUrl"
            class="avatar-uploader"
            :action="uploadActionUrl"
            name="image"
            :show-file-list="false"
            :before-upload="beforeAvatarUpload"
            :on-success="handleAvatarSuccess">
            <img v-if="formData.headPortraitUrl" :src="formData.headPortraitUrl" class="avatar">
            <i v-else class="el-icon-plus avatar-uploader-icon"></i>
          </el-upload>
        </el-form-item>

      <el-form-item label="用户" prop="adminName" type="text"  style="margin-right: 40px">
        <el-input v-model="formData.adminName"  style="width: 100px" ></el-input>
      </el-form-item>

        <el-form-item label="生日" prop="birthday">
        <el-date-picker type="date" placeholder="选择日期" v-model="formData.birthday" style="width: 140px;"></el-date-picker>
        </el-form-item>

      <el-form-item label="性别"  prop="sex" style="margin-right: 30px" >
        <el-radio v-model="formData.sex" label="1">男</el-radio>
        <el-radio v-model="formData.sex"  label="0">女</el-radio>
      </el-form-item>

        <el-form-item label="学院" prop="school">
          <el-input v-model="formData.school" style="width: 110px"></el-input>
        </el-form-item>

      <el-form-item label="年龄" prop="age"   style="margin-right: 40px">
        <el-input v-model="formData.age" style="width: 100px"></el-input>
      </el-form-item>

        <el-form-item label="专业" prop="vocational" maxlength="10">
          <el-input v-model="formData.vocational" style="width: 100px"></el-input>
        </el-form-item>

        <el-form-item label="学历" prop="education" style="margin-right: 40px">
          <el-select v-model="formData.education" placeholder="请选择学历" style="width: 100px">
            <el-option label="高中" value="高中"></el-option>
            <el-option label="专科" value="专科"></el-option>
            <el-option label="本科" value="本科"></el-option>
            <el-option label="研究生" value="研究生"></el-option>
            <el-option label="保密" value="保密"></el-option>
          </el-select>
        </el-form-item>

        <el-form-item label="英语水平" prop="englishLevel" >
          <el-select v-model="formData.englishLevel" placeholder="请选择水平" style="width: 100px">
            <el-option label="CET-4" value="CET-4"></el-option>
            <el-option label="CET-6" value="CET-6"></el-option>
            <el-option label="TEM-4" value="TEM-4"></el-option>
            <el-option label="TEM-8" value="TEM-8"></el-option>
          </el-select>
        </el-form-item>

      <el-form-item label="qq" prop="qq" style="margin-right: 30px" >
        <el-input v-model="formData.qq" style="width: 110px"></el-input>
      </el-form-item>

        <el-form-item label="gitee地址" prop="giteeFactoryUrl">
          <el-input v-model="formData.giteeFactoryUrl" style="width: 180px"></el-input>
        </el-form-item>

      <el-form-item label="身高(cm)" prop="height"   style="margin-right: 40px">
        <el-input v-model="formData.height" style="width: 100px"></el-input>
      </el-form-item>

        <el-form-item label="csdn地址" prop="csdnUrl">
          <el-input v-model="formData.csdnUrl" style="width: 180px"></el-input>
        </el-form-item>

      <el-form-item label="体重(kg)" prop="weight"   style="margin-right: 40px">
        <el-input v-model="formData.weight"  style="width: 100px"></el-input>
      </el-form-item>

        <el-form-item label="github地址" prop="githubUrl">
          <el-input v-model="formData.githubUrl" style="width: 180px"></el-input>
        </el-form-item>

        <el-form-item label="血型" prop="blood" style="margin-right: 40px">
          <el-select v-model="formData.blood" placeholder="请选择血型" style="width: 100px">
            <el-option label="A型" value="A型"></el-option>
            <el-option label="B型" value="B型"></el-option>
            <el-option label="C型" value="C型"></el-option>
            <el-option label="O型" value="O型"></el-option>
          </el-select>
        </el-form-item>

        <el-form-item label="邮件" prop="email">
          <el-input v-model="formData.email" style="width: 180px" ></el-input>
        </el-form-item>

      <el-form-item style="margin-left: 200px; margin-top: 20px">
        <el-button type="primary" @click="submitForm('formData')">提交</el-button>
        <el-button @click="resetForm('formData')">重置</el-button>
      </el-form-item>
      </div>

    </el-form>
  </el-dialog>

  </div>
</template>


<script>
import request from "../../utils/axiosUtils";
import base_url from "../../utils/Constants";

export default {
  data: function () {
    //检查age
    var checkAge = (rule, value, callback) => {
      if (!value) {
        return callback(new Error("年龄不能为空"));
      }
      if (!Number.isInteger(parseInt(value))) {
        callback(new Error('请输入数字值'));
      } else {
        if (value < 0 || value >= 200) {
          callback(new Error("请输入正确的年龄"))
        } else {
          callback();
        }
      }

    };
    //检查QQ
    var checkQQ = (rule, value, callback) => {
      if (!value) {
        return callback(new Error("qq不能为空"));
      }
      if (!Number.isInteger(parseInt(value))) {
        callback(new Error('请输入数字值'));
      } else {
        callback();
      }

    };
    //生日
    var checkBirthday = (rule, value, callback) => {
      //当前时间
      if (!value) {
        return callback(new Error('生日不能为空'))
      }

      callback();
    }

    /*  //检查专业
      var checkText=(rule,value,callback)=>{
        if (value===''){
          return callback(new Error('专业不能为空'))
        }
        let nameCheck = /^[\u2E80-\u9FFFa-zA-Z0-9]{1,10}$/;
        if (!nameCheck.test(value)){
        return  callback(new Error('格式有误'))
        }
          callback()

      };

      //检查学校
      var checkSchool=(rule,value,callback)=>{
          if (value=== ''){
            return callback(new Error('学校不能为空'))
          }
        let nameCheck = /^[\u2E80-\u9FFFa-zA-Z0-9]{1,10}$/;
        if (!nameCheck.test(value)){
         return  callback(new Error('格式有误'))
        }
          callback()
      };*/
    //身高
    var checkHeight = (rule, value, callback) => {
      if (!value) {
        return callback(new Error('身高不能为空'))
      }
      if (!Number.isInteger(parseInt(value))) {
        return callback(new Error('请输入数值'));
      }
      if (value < 0) {
        return callback(new Error("请输入正确的数值"))
      }
      callback();
    };
    //体重
    var checkWeight = (rule, value, callback) => {
      if (!value) {
        return callback(new Error('体重不能为空'))
      }
      if (!Number.isInteger(parseInt(value))) {
        return callback(new Error('请输入数值'))
      }
      if (value <= 0) {
        return callback(new Error('请输入正确的数值'))
      }
      callback();
    };
    //地址
    var checkUrl = (rule, value, callback) => {
      if (!value) {
        return callback(new Error('地址不能为空'))
      }
      var url = /^(https?:\/\/)?([\da-z\.-]+)\.([a-z\.]{2,6})([\/\w \.-]*)*\/?$/;
      if (!url.test(value)) {
        return callback(new Error('地址格式有误'))
      }
      callback();
    };
    //邮箱
    var checkEmail = (rule, value, callback) => {
      if (!value) {
        return callback(new Error('邮箱不能为空'))
      }
      let email = /^([a-z0-9_\.-]+)@([\da-z\.-]+)\.([a-z\.]{2,6})$/;
      if (!email.test(value)) {
        return callback(new Error('邮箱格式错误'))
      }
      callback();
    }

    return {
      //管理员id
      id:null,
      // dis:disabled,
      adminInfo:{},
      tableData: [
        {
          id: null,
          adminName: null,
          password: null,
          headPortraitUrl: null,
          sex: null,
          age: null,
          education: null,
          qq: null,
          height: null,
          weight: null,
          blood: null,
          birthday: null,
          school: null,
          vocational: null,
          englishLevel: null,
          giteeFactoryUrl: null,
          csdnUrl: null,
          githubUrl: null,
          email: null,
          recentLogin: null,
          createTime: null,
          updateTime: null,
        }
      ],

      // 对话框表可见
      dialogFormVisible: false,
      formData: {},
      rules: {
        //姓名
        adminName: [
          {required: true, message: '请输入用户', trigger: 'blur'},
          {min: 2, max: 5, message: '长度在2到5个字符', trigger: 'blur'}
        ],
        //年龄
        age: [
          {required: true, validator: checkAge, trigger: 'blur'},
        ],
        //学历
        education: [
          {required: true, message: '请输入学历', trigger: 'blur'},
        ],
        //qq
        qq: [
          {required: true, validator: checkQQ, trigger: 'blur'}
        ],
        //头像
        headPortraitUrl: [
          {required: true, message: '头像不能为空', trigger: 'blur'}
        ],
        //生日
        birthday: [
          {required: true, validator: checkBirthday, trigger: 'change'}
        ],
        //血型
        blood: [
          {required: true, message: '请选择血型', trigger: 'change'}
        ],
        //英语水平
        englishLevel: [
          {required: true, massage: '请选择英语水平', trigger: 'change'}
        ],
        //专业
        vocational: [
          {required: true, message: '请输入用户', trigger: 'blur'},
          {min: 2, max: 10, message: '长度在2到10个字符', trigger: 'blur'}
        ],
        //学校
        school: [
          {required: true, message: '请输入用户', trigger: 'blur'},
          {min: 2, max: 10, message: '长度在2到10个字符', trigger: 'blur'}
        ],
        //身高
        height: [
          {required: true, validator: checkHeight,trigger : 'blur'}
        ],
        //体重
        weight: [
          {required: true, validator: checkWeight, trigger: 'blur'}
        ],
        //gitee地址
        giteeFactoryUrl: [
          {required: true, validator: checkUrl, trigger: 'blur'}
        ],
        //CSDN地址
        csdnUrl: [
          {required: true, validator: checkUrl, trigger: 'blur'}
        ],
        //github地址
        githubUrl: [
          {required: true, validator: checkUrl, trigger: 'blur'}
        ],
        //邮箱
        email: [
          {required: true, validator: checkEmail, trigger: 'blur'}
        ],
        //性别
        sex: [
          {required: true, message: '请选择活动资源', trigger: 'change'}
        ],
      },
      uploadActionUrl:base_url+"/uploadImage"
    }
  },
  watch:{
    'formData.birthday':function (newValue) {

      let currentTime = new Date().getTime();
      let data = new Date(newValue);
      let year = this.handleZero(data.getFullYear());
      let month =this.handleZero( (data.getMonth() + 1));
      let day = this.handleZero(data.getDate());
      var formatting = year + '-' + month + '-' + day;
      let logingTime = new Date(formatting).getTime();
      let min = currentTime - logingTime;

      let years = parseInt(min / (60 * 60 * 24 * 30 * 12 * 1000));
      this.formData.age=years;

      this.tableData.birthday=this.dateFormat(new Date(newValue));
    }
  },

  methods: {

    //处理头像之前
    beforeAvatarUpload(file) {
      const isJPG = file.type === 'image/jpeg';
      const isPng = file.type === 'image/png';
      const isLt2M = file.size / 1024 / 1024 < 2;
      if (isJPG) {
        if (!isLt2M) {
          this.$message.error('上传头像图片大小不能超过 2MB!');
          return false;
        }
        return true;
      } else if (isPng) {
        if (!isLt2M) {
          this.$message.error('上传头像图片大小不能超过 2MB!');
          return false;
        }
        return true;
      } else {
        this.$message.error('上传头像图片只能是 JPG或PNG 格式!');
        return false;
      }
    },
    //处理头像成功
    handleAvatarSuccess(result) {
      // console.log(result)
      if (result.flag) {
        this.formData.headPortraitUrl = result.data;
      } else {
        this.$notify.error({
          title: '图片错误',
          duration: 6000,
          message: result.message
        });
      }
    },

    //编辑
    handleEdit(index, row) {

      row.sex=row.sex+"";
      let data = new Date(row.birthday);
      let y = this.handleZero(data.getFullYear().toString());
      let m = this.handleZero((data.getMonth()+1).toString());
      let d = this.handleZero(data.getDate().toString());
      let time=  y + "-" + m + "-" + d;
      row.birthday=time;
      // console.log(row.birthday);
      this.formData=row;

      // console.log(row)
      this.dialogFormVisible=true;
    },

    //表单提交
    submitForm(formData){
      let that = this;
      let data = new Date(this.formData.birthday);
      let y = this.handleZero(data.getFullYear().toString());
      let m = this.handleZero((data.getMonth()+1).toString());
      let d = this.handleZero((data.getDate()+1).toString());
      let time=  y + "-" + m + "-" + d;
      this.formData.birthday=time;
      // console.log(this.formData.birthday);
      this.$refs[formData].validate((valid) => {

        if (valid) {
          this.$confirm('此操作将修改用户信息，是否继续?','警告',{
            confirmButtonText:'确定',
            cancelButtonText:'取消',
            type:'warning'
          }).then(()=>{
            request({
              url:'/admin/updataAdmin',
              method:'get',
              params:{
                adminUserJson:that.formData,
                adminInfo:that.adminInfo
              }
            }).then(response=>{
              this.dialogFormVisible = false;
              if(response.data.flag){
                this.$notify.success({
                  title:'修改',
                  duration:2000,
                  message:response.data.message
                });
                this.getAdminList();
              }

            })
          }).catch(()=>{
            this.$message({
              type:'success',
              message:'已取消'
            });
          });

        } else {
          // console.log('error submit!!');
          return false;
        }
      });

    },

    //取消修改用户信息
    cancel(formName) {
      this.$refs[formName].resetFields();
      this.editDialogVisible = false;
    },

    //重置
    resetForm(formName) {
      this.$refs[formName].resetFields();
    },

    //生日
    dateFormat(data){

          let y = this.handleZero(data.getFullYear().toString());
          let m = this.handleZero((data.getMonth()+1).toString());
          let d = this.handleZero(data.getDate().toString());

          return  y + "-" + m + "-" + d;
    },
    //最近登录
    recentLogin(data){
      let currentTime = new Date().getTime();
      let recentTime = new Date(
        data.substr(0, 4),
        parseInt(data.substr(5, 2)) - 1,
        data.substr(8, 2),
        data.substr(11, 2),
        data.substr(14, 2),
        data.substr(17, 2),
      ).getTime();
      let TimeDifference=currentTime-recentTime;
      let min = parseInt(TimeDifference/1000+"");
      let targetTime = null;
      if (min >= 60 * 60 * 24 * 30 * 12) {
        targetTime = parseInt(min / (60 * 60 * 24 * 30 * 12)) + "年前";
      } else if (min >= 60 * 60 * 24 * 30) {
        targetTime = parseInt(min / (60 * 60 * 24 * 30)) + "月前";
      } else if (min >= 60 * 60 * 24) {
        targetTime = parseInt(min / (60 * 60 * 24)) + "天前";
      } else if (min >= 60 * 60) {
        targetTime = parseInt(min / (60 * 60)) + "小时前";
      } else if (min >= 60) {
        targetTime = parseInt(min / 60) + "分前";
      } else {
        targetTime = min + "秒前";
      }
      return targetTime;

      },
    //注册时间
    registerTime(data){

      let time = new Date(
        data.substr(0, 4),
        parseInt(data.substr(5, 2)) - 1,
        data.substr(8, 2),
        data.substr(11, 2),
        data.substr(14, 2),
        data.substr(17, 2),
      );
      let year = time.getFullYear();
      let month = this.handleZero(time.getMonth() + 1);
      let day = this.handleZero(time.getDate());
      let hour = this.handleZero(time.getHours());
      let minute = this.handleZero(time.getMinutes());
      let second = this.handleZero(time.getSeconds());
      return year + '-' + month + '-' + day + ' ' + hour + ':' + minute + ':' + second;
    },

    handleZero(time) {
      if (time < 10) {
        return '0' + time;
      } else {
        return time
      }
    },
    //获取管理员信息
    getAdminList(){
      let that = this;
      request({
        url: '/admin/getAdminUser',
        method: 'get'
      }).then(response => {
        // console.log(response.data);
        response.data.data.forEach(value=>{
          //头像
          value.headPortraitUrl=base_url+'/getImage/'+value.headPortraitUrl;
          //生日
          value.birthday=that.dateFormat(new Date(value.birthday));
          //最近登录
          value.recentLogin=that.recentLogin(value.recentLogin);
          //注册时间
          value.createTime=that.registerTime(value.createTime);
          //更新时间
          value.updateTime=that.registerTime(value.updateTime);
        })
        that.tableData = response.data.data;
        // console.log(that.tableData)


      })
    },

  },
  mounted() {
    var item = window.sessionStorage.getItem('adminInfo');
  let data = JSON.parse(item);
  this.id=data.id
    this.adminInfo=data;
    this.getAdminList();

  }

}
</script>

<style>
.avatar-uploader .el-upload {
  border: 1px dashed #d9d9d9;
  border-radius: 6px;
  cursor: pointer;
  position: relative;
  overflow: hidden;
}

.avatar-uploader .el-upload:hover {
  border-color: #409EFF;
}

.avatar-uploader-icon {
  font-size: 28px;
  color: #8c939d;
  width: 130px;
  height: 130px;
  line-height: 130px;
  text-align: center;
}

.avatar {
  width: 130px;
  height: 130px;
  display: block;
}


</style>



// WEBPACK FOOTER //
// src/components/admin/AdminManager.vue